import React from 'react';

export default function ReferralProgramTermsContent() {
  return (
    <>
      <p>
        The Lesson Launchpad Referral Program rewards teachers who share Lesson Launchpad with other teachers.
      </p>
      <h2 className="h5 mt-4">How rewards work</h2>
      <ul>
        <li>Each teacher receives one referral code after joining the program.</li>
        <li>When a referred teacher becomes a paid subscriber, both the referrer and the referred teacher earn one free month.</li>
        <li>Rewards are issued only after the referred teacher&apos;s first successful Stripe payment.</li>
        <li>Referral credits have no cash value and are non-transferable.</li>
        <li>Credits do not expire while your account remains in good standing.</li>
        <li>Credits are applied automatically to future subscription invoices once you are a paid subscriber.</li>
      </ul>
      <h2 className="h5 mt-4">Eligibility and restrictions</h2>
      <ul>
        <li>Referral attribution must occur before account creation.</li>
        <li>Existing accounts cannot add a referral code retroactively.</li>
        <li>Self-referrals are not allowed.</li>
        <li>Only one reward is issued per referred account.</li>
        <li>Lesson Launchpad may withhold or revoke credits for fraud, abuse, or policy violations.</li>
      </ul>
      <h2 className="h5 mt-4">Sharing disclosure</h2>
      <p className="mb-0">
        If you share your referral link publicly, you should disclose that you may receive a free month if someone you refer becomes a paid subscriber.
      </p>
    </>
  );
}
